import React, {Component} from 'react';
import { connect }        from 'react-redux';
import moment             from 'moment';
import RenderComboTurma   from '../../../container/renderComboTurma';
import {GetRankingAlunos} from '../../../actions/usuarioAction';
import FlashCarregando    from '../../../container/FlashCarregando';
import FlashRetornoNulo   from '../../../container/FlashRetornoNulo';
import FotoPerfil         from '../../../container/renderFotoPerfil';
import {SetError}         from '../../../actions/notificacaoAction';
import { GetListaMenuTopo,
         GetListaSubMenuTopo} from '../../../actions/scopoAction';

class RankingAlunos extends Component {

    constructor(props) {
        super(props);
        this.state = { load1  : false,load2  : false}   
    }


    componentWillMount() {

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.relatorio.nomeModulo,link:this.props.menu.relatorio.home},
            {action:false,nome:'Ranking de Aluno'}
           ]);
        this.props.GetListaSubMenuTopo([]);
    }

    onChange(e) {
        e.preventDefault();
        if (e.target.value) {
            this.setState({load1: true,load2: false});
            this.props.GetRankingAlunos(e.target.value).then((response) => {
              this.setState({load2: true});
            }).catch((error) =>{
              this.props.SetError(500);
            });
        } else {
            this.setState({load1: false,load2: false});
        }
    }

    renderListRankingAlunos(){
        const listRankingAlunosTurma = this.props.alunosRankingTurma;
        if (listRankingAlunosTurma) {
            return listRankingAlunosTurma.map((elem, i) => {
                return <tr key={i}>
                            <td className="text-center">{i+1}º</td>
                            <td className="text-center"><FotoPerfil width="35" height="35" className="img-rounded" src={elem.use_foto} /></td>
                            <td className="text-center">{elem.use_nome}</td>
                            <td className="text-center">{`${elem.pontos_atividade}pts (${elem.desempenho_atividade}%)`}</td>
                            <td className="text-center">{`${elem.pontos_duelo}pts (${elem.desempenho_duelo}%)`}</td>
                            <td className="text-center">{`${elem.pontos_tarefa}pts (${elem.desempenho_tarefa}%)`}</td>
                            <td className="text-center">{elem.total_pontos}</td>
                            <td className="text-center">{moment(elem.use_ultimo_acesso).format("DD/MM/YYYY")}</td>
                        </tr>;
            });
        } else {
            return <tr><td colSpan={8} className="text-center"><FlashRetornoNulo/></td></tr>;
        }
    }

    render() {
        return (
            <div>
                <div className="container-bg">
                    <div className="panel-busca">
                        <form className="form-horizontal">
                            <div className="form-group">
                                <label className="col-sm-2 control-label">Turma</label>
                                <div className="col-sm-5">
                                    <RenderComboTurma funcaoChange={this.onChange.bind(this)}/>
                                </div>
                            </div>
                        </form>
                    </div>
                    {
                        !this.state.load1 ? "" : 
                        !this.state.load2 ? <FlashCarregando/> : <div className="table-responsive">
                        <div className="panel panel-azul-claro panel-cinza">
                            <div className="panel-body table-responsive">
                                <table className="table table_panel">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Posição</th>
                                            <th className="text-center">Foto</th>
                                            <th className="text-center">Aluno</th>
                                            <th className="text-center">% Desafio</th>
                                            <th className="text-center">% Batalha</th>
                                            <th className="text-center">% Missão</th>
                                            <th className="text-center">Pontos</th>
                                            <th className="text-center">Último Acesso</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      {this.renderListRankingAlunos()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
             session            : state.auth.session,
             menu               : state.configReducer.menu,
             alunosRankingTurma : state.usuarioReducer.allAlunosRankingTurma
           }
}

export default connect(mapStateToProps,{GetRankingAlunos,
                                        SetError,
                                        GetListaMenuTopo,
                                        GetListaSubMenuTopo})(RankingAlunos);


// WEBPACK FOOTER //
// ./src/components/professor/relatorios/ranking_aluno.js